export default {
  SET_IS_SHOWN: (state, val) => { state.isShown = val; },
};
